import { createSlice } from "@reduxjs/toolkit";
import { addAgesTreatedAPI, fetchagesTreadedTedails } from "./AddAgesTreatedActions";

const addAgesTreated = createSlice({
    name: "addAgesTreated",
    initialState: {
        isAgesTreatedDataLoading: false,
        agesTreatedData: {},
        error: null,
    },
    reducers: {
        // addAgesTreatedData: (state, action) => {
        //     state.agesTreatedData = action.payload
        // }
    },
      extraReducers: (builder) => {
            builder
                .addCase(addAgesTreatedAPI.pending, (state) => {
                    state.isAgesTreatedDataLoading = true;
                    state.error = null;
                })
                .addCase(addAgesTreatedAPI.fulfilled, (state, action) => {
                    state.isAgesTreatedDataLoading = false;
                    state.agesTreatedData = action.payload;
                })
                .addCase(addAgesTreatedAPI.rejected, (state, action) => {
                    state.isAgesTreatedDataLoading = false;
                    state.error = action.error.message;
                });
            builder
                .addCase(fetchagesTreadedTedails.pending, (state) => {
                    state.isAgesTreatedDataLoading = true;
                    state.error = null;
                })
                .addCase(fetchagesTreadedTedails.fulfilled, (state, action) => {
                    state.isAgesTreatedDataLoading = false;
                    state.agesTreatedData = action.payload?.data?.data?.accessPointExtendedResponseDTO;
                })
                .addCase(fetchagesTreadedTedails.rejected, (state, action) => {
                    state.isAgesTreatedDataLoading = false;
                    state.error = action.error.message;
                });
        },
});


export const { addAgesTreatedData } = addAgesTreated.actions;
export const addAgesTreatedAPIReducer = addAgesTreated.reducer;